interface QuoteTitleLike {
    header?: {
        title?: unknown;
        [key: string]: unknown;
    };
    [key: string]: unknown;
}

interface ResolveQuoteTitleSaveOverridesInput {
    quoteData?: QuoteTitleLike | null;
    currentQuoteTitle?: unknown;
    currentTitleEditedByUser?: unknown;
    titleChanged?: unknown;
}

/**
 * Resolve the top-level Project title authority for an immediate Stage 5 save.
 *
 * A populated quote header is not proof of a builder title edit. Older Project
 * rows can legitimately reopen with a header that differs from the top-level
 * title. Only the modal's field-specific title receipt may promote the header;
 * otherwise retain the live App title and its existing edited flag.
 */
export function resolveQuoteTitleSaveOverrides({
    quoteData = null,
    currentQuoteTitle = '',
    currentTitleEditedByUser = false,
    titleChanged = false,
}: ResolveQuoteTitleSaveOverridesInput = {}): {
    quoteTitle?: string;
    titleEditedByUser: boolean;
} {
    const currentTitle = typeof currentQuoteTitle === 'string'
        ? currentQuoteTitle.trim()
        : '';
    const candidateTitle = typeof quoteData?.header?.title === 'string'
        ? quoteData.header.title.trim()
        : '';
    const authoredTitle = titleChanged === true && candidateTitle
        ? candidateTitle
        : '';
    const effectiveTitle = authoredTitle || currentTitle;
    return {
        ...(effectiveTitle ? { quoteTitle: effectiveTitle } : {}),
        titleEditedByUser: authoredTitle
            ? true
            : currentTitleEditedByUser === true,
    };
}
